import { Link, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";

const HIDDEN_PREFIXES = ["/admin"];
const HIDDEN_EXACT = ["/apply", "/thank-you", "/payment-success"];

export default function StickyApplyCTA() {
  const { pathname } = useLocation();
  const hidden =
    HIDDEN_PREFIXES.some((p) => pathname.startsWith(p)) ||
    HIDDEN_EXACT.includes(pathname);
  if (hidden) return null;

  return (
    <Link
      to="/apply"
      data-testid="sticky-apply-cta"
      className="fixed z-40 bottom-5 left-5 inline-flex items-center gap-2 rounded-full px-4 sm:px-5 py-3 bg-blue-600 hover:bg-blue-500 text-white font-semibold text-sm shadow-[0_8px_30px_rgba(10,132,255,0.45)] transition-colors duration-200"
    >
      <Sparkles className="w-4 h-4" strokeWidth={2} />
      <span className="hidden xs:inline sm:inline">Apply For A Free Website</span>
      <span className="xs:hidden sm:hidden">Apply Free</span>
    </Link>
  );
}
